var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.isRead)?_c('span',{staticClass:"mailbox-read-time pull-right"},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){return _vm.markAsRead()}}},[_vm._v(_vm._s(_vm.markAsReadString))])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }